import { baseUrl } from "./baseUrl";
import buildUrl from "../utils/buildUrl";

export const getRejectedTrafficsRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/pre-processor-api/service-usages/rejected`,
    searchParams: params,
  });

export const getRejectedTrafficsDetailSearch = (params) =>
  buildUrl({
    url: `${baseUrl}/pre-processor-api/service-usages/pageable-search`,
    searchParams: params,
  });

export const getTrafficSliceableSearchRoute = (params) =>
  buildUrl({
    url: `${baseUrl}/pre-processor-api/service-usages/sliceable-search`,
    searchParams: params,
  });

export const getRejectedTrafficsDetailSearchXLS = (params) =>
  buildUrl({
    url: `${baseUrl}/pre-processor-api/service-usages/search`,
    searchParams: params,
  });

export const getRejectedTrafficsDetail = (params) =>
  buildUrl({
    url: `${baseUrl}/pre-processor-api/service-usages/pageable-search`,
    searchParams: params,
  });
